// @ts-nocheck
import { useCallback } from "react";
import { useParams } from "react-router-dom";

import { useMutation } from "@apollo/client";
import { GroupStatus } from "../../../gql-generated/types";
import { LensCache } from "../../lenses/api/cache";
import { GroupCache } from "../api/cache";
import { GroupsPagination } from "../api/cache/GroupsPagination";
import { saveGroupV2 } from "../api/mutations/saveGroupV2";
import {
    type SaveGroupV2Mutation,
    type SaveGroupV2MutationVariables,
} from "../api/mutations/saveGroupV2.gql-generated";

interface SaveGroupParams {
    id: string;
    name: string;
    status: GroupStatus;
    description?: string;
}
export function useSaveGroup() {
    const { orgId } = useParams();
    const [saveGroupMutation, { loading, error }] = useMutation<SaveGroupV2Mutation, SaveGroupV2MutationVariables>(
        saveGroupV2,
        {
            update: (
                cache,
                {
                    data: {
                        saveGroupV2: { connections, group },
                    },
                },
            ) => {
                if (group.status === GroupStatus.Archived) {
                    // NOTE: removing a group from cache won't work in all cases,
                    // because a cursor that points to a page that hasn't been loaded yet
                    // will skip first group in that page, because the cursor is offset-based
                    GroupsPagination.cache.evict(cache);

                    GroupCache.removeGroup(cache, group.id);

                    connections.forEach(({ connectionId, lens: { compoundId } }) => {
                        LensCache.removeConnection(cache, compoundId, connectionId);
                    });
                }
            },
        },
    );

    const saveGroup = useCallback(
        ({ id, name, status, description }: SaveGroupParams) =>
            saveGroupMutation({
                variables: {
                    id,
                    name,
                    status,
                    description,
                    organizationId: orgId,
                },
            }),
        [orgId, saveGroupMutation],
    );

    return { saveGroup, loading, error };
}
